module.exports = __webpack_public_path__ + "static/media/Witzig.37ab54bc.mp4";